<template>
  <div>
    <div class="line-metrics hide-scroll">
      <template v-for="key of Object.keys(key_list)">
        <div v-if="key_list[key].show" class="metric-item" @click="m__select_key(key)"
             :style="m__is_selected(key) ? `border-top: 4px solid ${key_list[key].color}` : ''">
          <div class="metric-title">{{ key_list[key].name }}</div>
          <div class="metric-value">
            <span>{{ m__short_value(metrics[key], key_list[key].percent, key_list[key].is_rounded) }}</span>
          </div>
          <div v-if="is_compare && compare_metrics[key] != null" class="metric-compare">
            <strong class="text-danger">{{
                m__short_value(compare_metrics[key], key_list[key].percent, key_list[key].is_rounded)
              }}</strong>
          </div>
          <div
            v-if="has_agency_plan() && plan_found && key_list[key].plan"
            style="margin-bottom: 5px">
            <strong class="text-primary">{{ $t('base.plan') }}: {{
                m__get_target_value(key_list[key].plan) |currency
              }}</strong>
            <br>
            <strong class="text-success">{{ $t('base.complete') }}: {{
                m__get_complete_percent(metrics[key], key_list[key].plan)
              }}</strong>
            <br>
            <strong v-if="m__get_remaining(metrics[key], key_list[key].plan)" class="text-danger">
              Còn lại: {{ m__get_remaining(metrics[key], key_list[key].plan) | currency }}</strong>
          </div>
        </div>
      </template>
    </div>

    <el-row style="margin-top: 10px">
      <el-col :sm="12" style="padding: 5px 10px 0 0">
        <strong class="text-primary" style="font-size: 13px; cursor: pointer" @click="show_dialog.table_view = true">
          {{ $t('base.view_data_detail') }}
        </strong>
      </el-col>
      <el-col :sm="12" class="text-right" style="padding: 5px 10px 0 0">
        <template v-for="key in Object.keys(key_list)" v-if="m__in_selected_key(key)">
          &nbsp;&nbsp;&nbsp;
          <span class="circle" :style="`background-color: ${key_list[key].color}`"></span>
          <span style="font-size: 13px">{{ key_list[key].name }}</span>
        </template>
      </el-col>
    </el-row>
    <MarketingLineChart style="margin-top: 5px; height: 220px; width: 100%" :reports="reports"
                        :key_list="key_list" :selected_key_list="selected_key_list">
    </MarketingLineChart>

    <el-dialog :visible.sync="show_dialog.table_view" :close-on-click-modal="false" width="1200px">
      <div slot="title" style="padding:10px">
        <div style="height: 30px;">
          <el-button size="mini" icon="el-icon-download" @click="m__export_data()">
            {{ $t('base.export_data') }}
          </el-button>
          <el-button size="mini" icon="el-icon-download" @click="m__export_data_group_by_date()">
            {{ $t('base.export_data_group_by_date') }}
          </el-button>
        </div>
        <div style="height: calc(90vh - 30px); overflow-y: scroll; padding: 5px">
          <el-table :data="c__reports" ref="table_view" height="calc(100vh - 120px)">
            <el-table-column prop="timestamp" :label="$t('base.timestamp')" min-width="150px"
                             v-if="m__is_show_index('impression')" sortable>
              <template slot-scope="scope">
                {{ scope.row.timestamp * 1000 | moment('DD-MM-YYYY HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column prop="impression" :label="$t('metric.impressions')" width="120px"
                             v-if="m__is_show_index('impression')" sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'impression') | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="click" :label="$t('metric.clicks')" width="120px"
                             v-if="m__is_show_index('click')"
                             sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'click') | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="ctr" :label="$t('metric.ctr')" width="100px" v-if="m__is_show_index('ctr')"
                             sortable>
              <template slot-scope="scope">
                {{ (m__get_report_property(scope.row, 'ctr') * 100).toFixed(1) }} %
              </template>
            </el-table-column>
            <el-table-column prop="checkout" :label="$t('metric.checkout')" width="100px"
                             v-if="m__is_show_index('checkout')" sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'checkout') }}
              </template>
            </el-table-column>
            <el-table-column prop="broad_order_amount" :label="$t('metric.items_sold')" width="150px"
                             v-if="m__is_show_index('broad_order_amount')" sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'broad_order_amount') }}
              </template>
            </el-table-column>
            <el-table-column prop="broad_gmv" label="GMV" width="120px" v-if="m__is_show_index('broad_gmv')"
                             sortable>
              <template slot-scope="scope">
                {{ m__calculate(m__get_report_property(scope.row, 'broad_gmv')) | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="cost" :label="$t('metric.expense')" width="120px" v-if="m__is_show_index('cost')"
                             sortable>
              <template slot-scope="scope">
                {{ m__calculate(m__get_report_property(scope.row, 'cost')) | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="atosa_cpc" label="CPC" width="120px"
                             v-if="m__is_show_index('click')"
                             sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'atosa_cpc') }}
              </template>
            </el-table-column>
            <el-table-column prop="broad_cir" label="CIR (ACOS)" width="120px" v-if="m__is_show_index('broad_cir')"
                             sortable>
              <template slot-scope="scope">
                {{ (m__get_report_property(scope.row, 'broad_cir') * 100).toFixed(1) }} %
              </template>
            </el-table-column>
            <el-table-column prop="broad_roi" label="ROI (ROAS)" width="120px" v-if="m__is_show_index('broad_roi')"
                             sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'broad_roi') }}
              </template>
            </el-table-column>
            <el-table-column prop="cpm" label="CPM" width="120px" v-if="m__is_show_index('cost')"
                             sortable>
              <template slot-scope="scope">
                {{ m__get_report_property(scope.row, 'cpm') | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="cr" :label="$t('metric.conversion_rate')" width="140px" v-if="m__is_show_index('cr')"
                             sortable>
              <template slot-scope="scope">
                {{ (m__get_report_property(scope.row, 'cr') * 100).toFixed(1) }} %
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MarketingLineChart from './line_chartjs'
import {fix_ads_mixins} from "../../../mixins/fix_ads";

export default {
  name: 'component_metric',

  mixins: [fix_ads_mixins],

  props: {
    metrics: {},
    show_checkout: false,
    reports: null,
    is_compare: false,
    compare_metrics: {},
    agency_file: null,
    flag: null,
    shop: null,
    campaign_type: null
  },

  components: {
    MarketingLineChart
  },

  data() {
    return {
      key_list: {
        impression: {
          name: this.$t('metric.impressions'),
          color: 'rgb(54, 127, 227)',
          show: true,
          plan: 'target_view_ads'
        },
        click: {
          name: this.$t('metric.clicks'),
          color: 'rgb(246, 189, 22)',
          show: !['live_stream_homepage'].includes(this.campaign_type),
          plan: 'target_click_ads'
        },
        ctr: {
          name: this.$t('metric.ctr'),
          color: 'rgb(35, 170, 171)',
          show: !['live_stream_homepage'].includes(this.campaign_type),
          percent: true,
          plan: 'target_ctr'
        },
        checkout: {
          name: this.$t('metric.checkout'),
          color: 'rgb(88, 183, 241)',
          show: true,
          plan: 'target_order_ads'
        },
        broad_order_amount: {
          name: this.$t('metric.items_sold'),
          color: 'rgb(251, 115, 75)',
          show: true
        },
        broad_gmv: {
          name: 'GMV',
          color: 'rgb(148, 95, 185)',
          show: true,
          plan: 'target_gmv_ads'
        },
        cost: {
          name: this.$t('metric.expense'),
          color: 'rgb(215,81,82)',
          show: true,
          plan: 'target_cost'
        },
        atosa_cpc: {
          name: 'CPC',
          color: 'rgb(105,39,255)',
          show: !['live_stream_homepage'].includes(this.campaign_type),
        },
        broad_cir: {
          name: 'CIR (ACOS)',
          color: 'rgb(104,116,133)',
          show: true,
          percent: true
        },
        broad_roi: {
          name: 'ROI (ROAS)',
          color: 'rgb(0, 191, 166)',
          show: true,
          percent: false,
          is_rounded: false
        },
        cr: {
          name: this.$t('metric.conversion_rate'),
          color: 'rgb(108, 117, 125)',
          show: !['live_stream_homepage'].includes(this.campaign_type),
          percent: true,
          is_rounded: false
        },
        aov: {
          name: 'AOV',
          color: 'rgb(0, 100, 0)',
          show: true,
          percent: false,
          is_rounded: false
        },
        cpm: {
          name: 'CPM',
          color: 'rgb(255, 87, 34)',
          show: true,
          percent: false,
          is_rounded: false
        },
      },
      selected_key_list: ['impression', 'click'],
      plan_found: null,
      show_dialog: {
        table_view: false
      }
    }
  },

  mounted() {
    this.key_list.checkout.show = this.show_checkout
  },

  watch: {
    'agency_file': function () {
      if (this.agency_file) {
        const found = JSON.parse(this.agency_file.data).find(i => this.dayjs(i.time, 'DD/MM/YYYY').date() === this.dayjs().date())
        if (found) {
          this.plan_found = found
        } else {
          this.plan_found = null
        }
      } else {
        this.plan_found = null
      }
    }
  },

  computed: {
    c__reports() {

      if (!this.reports || !this.reports.map) return []

      return this.reports.map(i => {
        for (const key of Object.keys(i)) {
          i[key] = Number(i[key])
        }

        i.ctr = i.impression ? +(i.click / i.impression) : 0
        i.broad_cir = +i.broad_gmv ? +(+i.cost / +i.broad_gmv) : 0
        i.broad_roi = +i.cost ? +(+i.broad_gmv / +i.cost).toFixed(1) : 0
        i.atosa_cpc = +i.click ? this.m__calculate(+i.cost / +i.click) : 0
        return i
      })
    }
  },

  methods: {
    async m__export_data_group_by_date() {
      const column_labels = this.$refs.table_view.columns.map(i => i.label)

      const group_data = {}
      for (const row of this.c__reports) {
        const date = this.dayjs(row.timestamp * 1000).format('DD/MM/YYYY')
        if (!group_data[date]) {
          group_data[date] = []
        }
        group_data[date].push(row)
      }

      const data = []
      for (const key of Object.keys(group_data)) {
        const summary = {}
        for (const row of group_data[key]) {
          for (const col of this.$refs.table_view.columns) {
            if (col.property !== 'timestamp') {
              if (!summary[col.property]) {
                summary[col.property] = 0
              }
              summary[col.property] += +row[col.property]
            }
          }
        }
        this.m__update_summary(summary)

        const item = []
        for (const col of this.$refs.table_view.columns) {
          if (col.property === 'timestamp') {
            item.push(key)
          } else {
            item.push(+summary[col.property])
          }
        }
        data.push(item)
      }

      const filename = `report_group_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    async m__export_data() {
      const column_labels = this.$refs.table_view.columns.map(i => i.label)
      const data = []
      for (const row of this.c__reports) {
        const item = []
        for (const col of this.$refs.table_view.columns) {
          if (col.property === 'timestamp') {
            item.push(this.dayjs(row.timestamp * 1000).format('DD/MM/YYYY HH:mm'))
          } else {
            item.push(+row[col.property])
          }
        }
        data.push(item)
      }

      const filename = `report_${this.shop.username}_${this.dayjs().format('DDMMYYYY')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        filename,
        data: [column_labels, ...data]
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },

    m__get_report_property(data, key) {
      return Number(data[key])
    },

    m__is_show_index(value) {
      if (!flag) return true

      const flag = this.flag.find(i => i.value === value)
      if (flag) {
        return flag.checked
      } else {
        return false
      }
    },

    m__get_target_value(key) {
      return this.plan_found ? this.plan_found[key] : 0
    },

    m__get_complete_percent(value, key) {
      if (!this.plan_found) {
        return '0.0%'
      }
      const target = this.plan_found[key]

      return target ? `${(+value * 100 / target).toFixed(1)}%` : '0.0%'
    },

    m__get_remaining(value, key) {
      if (!this.plan_found) {
        return 0
      }
      const target = this.plan_found[key]

      return +value < +target ? this.m__calculate(+target - +value) : 0
    },

    m__short_value(value, is_percent, is_rounded = true) {
      if (!value) return '0'
      if (!Number(value)) return value
      if (!is_percent && is_rounded) value = this.m__calculate(value)

      const one_thousand = 1000
      const one_million = one_thousand * one_thousand
      const one_billion = one_million * one_thousand

      let result = ''
      if (value >= one_billion) {
        result = `${(value / one_billion).toFixed(1)}b`
      } else if (value >= one_million) {
        result = `${(value / one_million).toFixed(1)}m`
      } else if (value >= one_thousand) {
        result = `${(value / one_thousand).toFixed(1)}k`
      } else {
        result = value
      }

      return `${result} ${is_percent ? '%' : ''}`
    },

    m__select_key(key) {
      if (this.selected_key_list.some(i => i === key) && this.selected_key_list.length === 1) {
        return
      }
      if (!this.selected_key_list.some(i => i === key) && this.selected_key_list.length === 4) {
        return
      }

      const index = this.selected_key_list.findIndex(i => i === key)
      if (index === -1) {
        this.selected_key_list.push(key)
      } else {
        this.selected_key_list.splice(index, 1)
      }
    },

    m__is_selected(key) {
      return this.selected_key_list.some(i => i === key)
    },

    m__in_selected_key(key) {
      return this.selected_key_list.includes(key)
    }
  }
}
</script>

<style lang="scss">
.line-metrics {
  margin-top: 10px;
  display: flex;
  width: 100%;
  //justify-content: space-around;
  overflow-x: scroll;
  padding-bottom: 10px;

  .metric-item:last-child {
    margin-right: 0 !important;
  }

  .metric-item {
    //width: 13%;
    //width: 11.5%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    //border-top: 4px solid;
    //margin-right: 1.5%;
    //margin-right: 1%;
    margin-right: 8px;
    padding-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    min-width: 120px;
  }

  .metric-title {
    height: 30px;
    font-size: 13px !important;
    line-height: 15px !important;
    color: #666;
    font-weight: bold;
  }

  .metric-value {
    margin-top: 10px;
    margin-bottom: 15px;

    span {
      font-size: 22px !important;
      line-height: 24px !important;
      color: #333;
      font-weight: bold;
    }
  }

  .metric-compare {
    margin-bottom: 5px;

    strong:before {
      content: '\25B8 \0020';
    }
  }
}

.circle {
  margin-right: 5px;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>




// WEBPACK FOOTER //
// src/pages/pas/component/component_metric.vue